import React from 'react';
import { FiEdit2, FiInfo } from 'react-icons/fi';

const FeeCard = ({ 
  item, 
  type, 
  isEditing, 
  onEdit, 
  onToggle, 
  children 
}) => {
  const getTypeBadge = () => {
    const config = {
      'platform': { bg: 'bg-blue-100', text: 'text-blue-800', label: 'Platform' },
      'processor': { bg: 'bg-orange-100', text: 'text-orange-800', label: 'Processor' },
      'tiered': { bg: 'bg-purple-100', text: 'text-purple-800', label: 'Tiered' },
      'split': { bg: 'bg-green-100', text: 'text-green-800', label: 'Split' }
    };
    
    const { bg, text, label } = config[type] || { bg: 'bg-gray-100', text: 'text-gray-800', label: type };
    return (
      <span className={`px-3 py-1 rounded-full text-xs font-medium ${bg} ${text}`}>
        {label}
      </span>
    );
  };

  return (
    <div className="bg-gray-50 rounded-xl border border-gray-200 p-5 hover:border-gray-300 transition-colors">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-2">
          <span className={`px-3 py-1 rounded-full text-xs font-medium ${item.is_active ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`}>
            {item.is_active ? 'Active' : 'Inactive'}
          </span>
          {getTypeBadge()}
        </div>
        <div className="flex items-center space-x-2">
          <button
            onClick={() => onToggle(item)}
            className={`px-3 py-1 rounded text-xs font-medium ${item.is_active ? 'bg-red-50 text-red-700 hover:bg-red-100' : 'bg-green-50 text-green-700 hover:bg-green-100'}`}
          >
            {item.is_active ? 'Deactivate' : 'Activate'}
          </button>
          <button
            onClick={() => onEdit(item)}
            className={`px-3 py-1 rounded text-xs font-medium ${isEditing ? 'bg-gray-100 text-gray-700' : 'bg-[#ff660e] text-white hover:bg-[#e55c0d]'}`}
          >
            {isEditing ? 'Cancel' : <FiEdit2 className="inline" />}
          </button>
        </div>
      </div>
      
      {children}
    </div>
  );
};

export default FeeCard;